import React from 'react'


export default function Users() {
    return (
        <div className='header'>
            <h1 className='header-title'>Usuários</h1>
            <p className='header-subtitle'>You have 24 new messages and 5 new notifications.</p>
        </div>
    )
}